import _ from 'lodash';
import React, { PureComponent} from "react"
import PropTypes from "prop-types"
import { getList, getExtensions, sanitizeUrl, escapeDeepLinkPath } from "core/utils"
import { Iterable, List } from "immutable"
import ImPropTypes from "react-immutable-proptypes"

export default class MqOperation extends PureComponent {
  static propTypes = {
    specPath: ImPropTypes.list.isRequired,
    operation: PropTypes.instanceOf(Iterable).isRequired,
    summary: PropTypes.string,
    response: PropTypes.instanceOf(Iterable),
    request: PropTypes.instanceOf(Iterable),

    toggleShown: PropTypes.func.isRequired,
    onTryoutClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onExecute: PropTypes.func.isRequired,

    getComponent: PropTypes.func.isRequired,
    getConfigs: PropTypes.func.isRequired,
    authActions: PropTypes.object,
    authSelectors: PropTypes.object,
    specActions: PropTypes.object.isRequired,
    specSelectors: PropTypes.object.isRequired,
    oas3Actions: PropTypes.object.isRequired,
    oas3Selectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,
    layoutSelectors: PropTypes.object.isRequired,
    fn: PropTypes.object.isRequired
  }

  static defaultProps = {
    operation: null,
    response: null,
    request: null,
    specPath: List(),
    summary: ""
  }

  constructor(props) {
    super(props);
    const {
      tag,
      operationId
    } = props.operation.toJS();
    let isShownKey = ["operations", tag, operationId];

    this.operationId = escapeDeepLinkPath(isShownKey.join("-"))
  }

  componentDidMount() {
    this.props.fn.readyToScroll(this.operationId)
  }

  processParameters(immParameters) {
    const parameters = immParameters.toJS();

    return parameters.reduce((finalParams, p) => {
      if (p.in === 'body') {
        const requiredFields = p.schema.required || [];
        const body = Object.keys(p.schema.properties).map(fieldKey => ({
          name: fieldKey,
          required: requiredFields.indexOf(fieldKey) >= 0,
          ...p.schema.properties[fieldKey],
          parentSchema: p.schema.$$ref
        }));

        return {
          ...finalParams,
          body
        };
      } else {// query or path parameter
        return {
          ...finalParams,
          [`${p.in}`]: [
            ...finalParams[p.in],
            _.omit(p, 'in')
          ]
        };
      }
    }, {query: [], path: [], body: []});
  }

  formatDescription(desc) {
    if (_.isEmpty(desc)) {
      return <div className="param-chart__val-desc"/>;
    }

    const regex = new RegExp(/Enum: \[[^)]+?\]/g);
    const matches = desc.match(regex);

    if (_.isEmpty(matches)) {
      return <div className="param-chart__val-desc">{desc}</div>;
    }

    const enumEls = matches.map((m, i) => {
      const pieces = m.slice(m.indexOf('[') + 1, -1).split(',');

      return (
        <span key={i}>
          Enum:
          {pieces.map((p, j) => (<span className="param-chart__enum-block" key={j}>"{p.trim()}"</span>))}
        </span>
      )
    });

    return (
      <div className="param-chart__val-desc">
        {_.reduce(desc.split(regex), (descPieces, dPiece, index) => ([
          ...descPieces,
          dPiece,
          ...!_.isUndefined(enumEls[index]) && [enumEls[index]]
        ]), [])}
      </div>
    );
  }

  render() {
    let {
      specPath,
      response,
      request,
      // toggleShown,
      onTryoutClick,
      onCancelClick,
      onExecute,
      fn,
      getComponent,
      getConfigs,
      specActions,
      specSelectors,
      authActions,
      authSelectors,
      oas3Actions
    } = this.props
    let operationProps = this.props.operation

    let {
      deprecated,
      // isShown,
      path,
      method,
      op,
      allowTryItOut,
      displayRequestDuration,
      tryItOutEnabled,
      executeInProgress,
      isAuthorized
    } = operationProps.toJS()

    let {
      description,
      externalDocs
    } = op

    let operation = operationProps.getIn(["op"])
    let responses = operation.get("responses")
    let produces = operation.get("produces")
    let parameters = getList(operation, ["parameters"])
    let extensions = getExtensions(operation)

    const Responses = getComponent("responses")
    const Parameters = getComponent( "parameters" )
    const Execute = getComponent( "execute" )
    const Clear = getComponent( "clear" )
    const Markdown = getComponent( "Markdown" )
    const OperationExt = getComponent( "OperationExt" )
    // const OperationSummary = getComponent( "OperationSummary" )
    const Link = getComponent( "Link" )
    const TryItOutButton = getComponent("TryItOutButton")
    const AuthorizeOperationBtn = getComponent("authorizeOperationBtn")
    const MqSubParameters = getComponent("mqsubparameters")

    const { showExtensions } = getConfigs()
    const summary = operationProps.get("summary");
    const processedParams= (parameters && parameters.size > 0) ? this.processParameters(parameters) : {};

    // Merge in Live Response
    if(responses && response && response.size > 0) {
      let notDocumented = !responses.get(String(response.get("status"))) && !responses.get("default")
      response = response.set("notDocumented", notDocumented)
    }

    let onChangeKey = [ path, method ] // Used to add values to _this_ operation ( indexed by path and method )
    const methodTag = operationProps.get("method");
    let security = operationProps.get("security")
    const isExecute = tryItOutEnabled && allowTryItOut

    return (
      <div className="grid opblock-body" id={this.operationId}>
        <div className="col__sm-12 col__lg-6 swag-content__summary">
          {/* // NOTE: part of the accordion click to load stuff. not sure if needed
            <OperationSummary operationProps={operationProps} toggleShown={toggleShown} getComponent={getComponent} authActions={authActions} authSelectors={authSelectors} specPath={specPath} />
          */}

          <h5 className="swag-content__title">{summary}</h5>

          <h6 className={`swag-content__sub-title ${!_.isEmpty(methodTag) ? 'method-badge' + ' _method--' + methodTag + '' : ''}`}>
            <span className="method-badge__item">{methodTag}</span>
            <span className="swag-content__sub-title-content">{path}</span>
          </h6>

          { deprecated && <h4 className="opblock-title_normal"> Warning: Deprecated</h4>}
          { description &&
            <div className="opblock-description-wrapper">
              <div className="opblock-description">
                <Markdown source={description} />
              </div>
            </div>
          }
          {
            externalDocs && externalDocs.url ?
            <div className="opblock-external-docs-wrapper">
              <h4 className="opblock-title_normal">Find more details</h4>
              <div className="opblock-external-docs">
                <span className="opblock-external-docs__description">
                  <Markdown source={externalDocs.description} />
                </span>
                <Link target="_blank" className="opblock-external-docs__link" href={sanitizeUrl(externalDocs.url)}>{externalDocs.url}</Link>
              </div>
            </div> : null
          }

          {processedParams &&
            <div className="param">
              {['path', 'query', 'body'].map(paramType => _.isEmpty(processedParams[paramType]) ? null : (
                <div key={paramType}>
                  <h3 className="param__title">{_.capitalize(paramType)} Parameters</h3>

                  {processedParams[paramType].map((pField, i) => {
                    let fieldDescription = pField.description || pField.title

                    if (_.isEmpty(fieldDescription) && paramType === 'body') {
                      const schemaPath = pField.parentSchema.split('/').slice(-1)[0];

                      if (!specSelectors.definitions().has(schemaPath)) {
                        // spec has not updated to match current params
                        return null
                      }

                      const currentSchema = specSelectors.definitions().get(schemaPath).toJS();
                      const propKeyFields = _.get(currentSchema, `properties.${pField.name}`, {});

                      fieldDescription = propKeyFields.description || propKeyFields.title || pField.parentSchema
                    }

                    return (
                      <div className="grid param-chart" key={pField + i}>
                        <div className="col__sm-6 param-chart__key">
                          {pField.name}
                          {pField.required &&
                            <span className="parameter__name required"> *</span>
                          }
                        </div>
                        <div className="col__sm-6 param-chart__val">
                          <div className="param-chart__val-type">{pField.type}{pField.format && ` <${pField.format}>`}</div>
                          {this.formatDescription(fieldDescription)}
                        </div>
                        {_.get(pField, 'items.type', '') === 'object' &&
                          <MqSubParameters
                            items={pField.items}
                            getComponent={getComponent}
                          />
                        }
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          }

          {(responses && responses.size > 0) &&
            <div className="param">
              <h3 className="param__title">Responses</h3>

              {Object.keys(responses.toJS()).map((respsStatus, index) => { // TODO: Revisit this and output the http status for the response along with it all
                const resps = responses.get(respsStatus).toJS();
                // until the TOOD above is addressed, skip default responses to reduce
                // ui change from gogo to go proto migration
                const isDefaultResponse = respsStatus === 'default';
                const noSchemaProps = !_.has(resps, 'schema.properties')
                return isDefaultResponse || noSchemaProps ? null : (
                  <div key={index}>
                    {Object.keys(resps.schema.properties).map((propKey, i) => {
                      const resProp = resps.schema.properties[propKey];
                      let fieldDescription = resProp.description || resProp.title;

                      if (_.isEmpty(fieldDescription)) {

                        const schemaPath = resps.schema.$$ref.split('/').slice(-1)[0];
                        if (!specSelectors.definitions().has(schemaPath)) {
                          // spec has not updated to match current params
                          return null
                        }

                        const currentSchema = specSelectors.definitions().get(schemaPath).toJS();
                        const propKeyFields = _.get(currentSchema, `properties.${propKey}`, {});

                        fieldDescription = propKeyFields.description || propKeyFields.title || resps.schema.$$ref
                      }
                      return (
                        <div className="grid param-chart" key={propKey + i}>
                          <div className="col__sm-6 param-chart__key">
                            {propKey}
                          </div>
                          <div className="col__sm-6 param-chart__val">
                            <div className="param-chart__val-type">{resProp.type}</div>
                            {this.formatDescription(fieldDescription)}
                          </div>
                        </div>
                      );
                    })}
                </div>
                )
              })}
            </div>
          }

        </div>
        <div className="col__sm-12 col__lg-6 swag-content__code-blocks-wrap">
          <div className="swag-content__code-blocks">
            {allowTryItOut &&
              <TryItOutButton
                enabled={tryItOutEnabled}
                onCancelClick={onCancelClick}
                onTryoutClick={onTryoutClick}
              />
            }

            {(security && security.count()) &&
              <AuthorizeOperationBtn
                isAuthorized={isAuthorized}
                onClick={() => {
                  const applicableDefinitions = authSelectors.definitionsForRequirements(security)
                  authActions.showDefinitions(applicableDefinitions)
                }}
              />
            }

            {(parameters && parameters.count() > 0) &&
              <div>
                {(parameters.filter((p) => p.get('in') === 'body').size > 0 || isExecute) &&
                  <p className="swag-content__code-blocks__title">Request {isExecute ? 'Body' : 'Sample'}</p>
                }

                <Parameters
                  parameters={parameters}
                  specPath={specPath.push("parameters")}
                  operation={operation}
                  onChangeKey={onChangeKey}
                  onTryoutClick = {onTryoutClick}
                  onCancelClick = {onCancelClick}
                  tryItOutEnabled = {tryItOutEnabled}
                  allowTryItOut={allowTryItOut}

                  fn={fn}
                  getComponent={getComponent}
                  specActions={specActions}
                  specSelectors={specSelectors}
                  pathMethod={[path, method]}
                  getConfigs={getConfigs}
                />
              </div>
            }

            {/* NOTE: this is the 'execute' button - displays in 'try it out' mode */}
            <div className={(!tryItOutEnabled || !response || !allowTryItOut) ? "execute-wrapper" : "btn-group"}>
              { !tryItOutEnabled || !allowTryItOut ? null :
                  <Execute
                    operation={operation}
                    specActions={specActions}
                    specSelectors={specSelectors}
                    path={path}
                    method={method}
                    onExecute={onExecute}
                  />
              }

              {/* NOTE: this is the 'clear' button - displays in 'try it out' mode */}
              { (!tryItOutEnabled || !response || !allowTryItOut) ? null :
                  <Clear
                    specActions={specActions}
                    path={path}
                    method={method}
                  />
              }
            </div>

            {executeInProgress &&
              <div className="loading-container">
                <div className="loading"/>
              </div>
            }

            { !responses ? null :
                <Responses
                  responses={responses}
                  request={request}
                  tryItOutResponse={response}
                  getComponent={getComponent}
                  getConfigs={getConfigs}
                  specSelectors={specSelectors}
                  oas3Actions={oas3Actions}
                  specActions={specActions}
                  produces={produces}
                  producesValue={specSelectors.currentProducesFor([path, method])}
                  specPath={specPath.push("responses")}
                  path={path}
                  method={method}
                  displayRequestDuration={displayRequestDuration}
                  fn={fn}
                />
            }

            { !showExtensions || !extensions.size ? null :
              <OperationExt extensions={extensions} getComponent={getComponent} />
            }
          </div>

        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/machineq/components/MqOperation.jsx